<template>
    <el-row :gutter="30"  class="mw-100 manage-value" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentValueData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addValueRef"
                            :model="currentValueData"
                            :rules="currentValueDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                                <el-col :lg="24" :xs="24">
                                    <el-form-item>
                                        <el-button type="primary" @click="manageValue('addValueRef',index)" class="text-cap">
                                            <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                            save
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="4" :xs="24">
                                    <el-form-item  label="value order"  >
                                        <el-input type="text" v-model="currentValueData.seq"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="12" :xs="24">
                                    <el-form-item  label="value image" prop="imageBase64">
                                        <el-image 
                                            style="width: 150px; height: 150px;margin-right:20px" 
                                            :src="isAddValue ? currentValueData.imageURL :  $getImage(currentValueData.imageURL) || ''" 
                                            fit="cover"
                                            :zoom-rate="1.2"
                                            :preview-src-list="[isAddValue ? currentValueData.imageURL : $getImage(currentValueData.imageURL)]"
                                            :preview-teleported="true"
                                        >
                                            <template #error>
                                                <div class="image-slot">
                                                    <font-awesome-icon :icon="['fas', 'image']" />
                                                </div>
                                            </template>
                                        </el-image>
                                        <el-upload
                                            ref="imageBase64"
                                            action="#"
                                            :auto-upload="false"
                                            :on-change="onUploadImage"
                                            :disabled="fileUploaded"
                                            :on-remove="handleRemoveImage"
                                            accept="image/png, image/jpeg,image/gif"
                                            class="font-24 d-flex align-center flex-1"
                                        >
                                            <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                                
                                
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentValueData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                                
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    data(){
        return {
            isAddValue:true,
            currentValue:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentValueData:{},
            currentValueDataRules:{
                translates:this.$setTranslateRules(['title']),
            }
        };
    },
    computed:{
        cachedValue(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website.values.currentValue || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedValue.id) {
            this.isAddValue = false;
            this.currentValueData = JSON.parse(JSON.stringify(this.cachedValue))
            this.currentValueData.translates = this.$filterPublishedTranslates(this.currentValueData.translates)
        }else{
            this.$router.push({
                name:'manage-value',
            })
            this.currentValueDataRules.imageBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
            this.isAddValue = true;
            this.currentValueData = this.initState()
        }
    },
    
    methods:{
        initState(){
            return {
                
                translates:this.$setTranslateKeys({
                    'title':'',
                })
            }
        },
       
        async manageValue(formName){
            let successForm = [];
            for (let index = 0; index < this.$refs[formName].length; index++) {
                const element = this.$refs[formName][index];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    let indexOfIndex = successForm.indexOf(index);
                    if (data){
                        successForm.push(index);
                        if (successForm.length == this.$refs['addValueRef'].length){
                            this.manageValueAfterValidate()
                        }
                    }else{
                        if(indexOfIndex != -1) {
                            successForm.splice(indexOfIndex,1);
                        }
                    }
                })  
            }
           
            
            
            
            
            
        },
        async manageValueAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddValue ? 'addValue':'editValue',this.currentValueData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllValues');
                this.$router.push({
                    name:'values-list'
                })
            }
        },
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['imageBase64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentValueData.imageBase64 = evt.target.result;
                }); 
                this.currentValueData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        },    
        handleRemoveImage(){
            this.currentValueData.imageURL = this.isAddValue ? '' : this.cachedValue.imageURL
        }, 
    }
}
</script>
<style lang="scss">
    .manage-value {
        .ck-editor {
            width:100%;
        }
    }
</style>